import { COLORS } from './constants';
/**

The constants in this file should not be exported or used outside this library.
The values here are meant for aligning across components internally.

 */

export var ButtonStyles = {
  transitionBehaviour: '300ms ease-out',
  primary: {
    hover: '#2b70ac'
  },
  success: {
    hover: '#0b8c5d'
  },
  critical: {
    hover: '#c93c4a'
  }
}; // // Color variations not included in UI kit

export var ColorVariations = {
  darkBlue: '#2471b3',
  primaryBlueOpacity: 'rgba(54, 140, 215, .07)',
  cardBorderGrayOpacity: 'rgba(223, 226, 229, .6)'
};
export var CheckControlStates = {
  labelColor: COLORS.grays.darkest,
  labelColorDisabled: '#D8D8D8',
  "default": {
    background: COLORS.white,
    border: "1px solid " + COLORS.grays.lighter,
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.13)'
  },
  defaultHover: {
    border: "1px solid " + COLORS.blues.primary,
    boxShadow: 'none'
  },
  defaultFocus: {
    border: "2px solid " + COLORS.blues.primary,
    boxShadow: "0 0px 0px 2px " + COLORS.blues.lightest
  },
  defaultDisabled: {
    background: COLORS.grays["super"],
    border: "1px solid " + COLORS.grays.cardBorder,
    cursor: 'not-allowed',
    boxShadow: 'none'
  },
  checked: {
    background: COLORS.blues.primary,
    border: "1px solid " + COLORS.blues.primary,
    boxShadow: 'none'
  },
  checkedHover: {
    background: ColorVariations.darkBlue,
    borderColor: ColorVariations.darkBlue
  },
  checkedFocus: {
    background: ColorVariations.darkBlue,
    border: "1px solid " + ColorVariations.darkBlue,
    boxShadow: "0 0px 0px 2px " + COLORS.blues.lightest
  },
  checkedDisabled: {
    background: COLORS.grays.lighter,
    border: "1px solid " + COLORS.grays.lighter,
    boxShadow: 'none',
    cursor: 'not-allowed'
  }
};
export var zIndexLevels = {
  modalBackdrop: 101,
  modalContent: 102,
  popover: 102,
  globalAlert: 999,
  pageLoaderBackdrop: 9998,
  pageLoaderContent: 9999
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/internalConstants.js
// module id = 25
// module chunks = 0